import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfService: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    return (
        <div className="container mx-auto py-8 px-4 max-w-4xl">
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400 transition-colors mb-6"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                {language === 'tr' ? 'Geri Dön' : 'Go Back'}
            </button>

            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-200 dark:border-gray-700">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
                    {language === 'tr' ? 'Kullanım Şartları' : 'Terms of Service'}
                </h1>

                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    {language === 'tr'
                        ? 'Son güncelleme: 19 Ocak 2026'
                        : 'Last updated: January 19, 2026'}
                </p>

                <div className="prose dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">
                    {language === 'tr' ? (
                        <>
                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">1. Hizmet Tanımı</h2>
                                <p>
                                    ServeRS, Metin2 özel sunucularını listeleyen ve kullanıcıların bu sunucuları değerlendirmesine
                                    olanak tanıyan bir platformdur. Platformumuzu kullanarak bu kullanım şartlarını kabul etmiş sayılırsınız.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">2. Hesap Sorumlulukları</h2>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>Hesabınızın güvenliğinden siz sorumlusunuz</li>
                                    <li>Şifrenizi başkalarıyla paylaşmamalısınız</li>
                                    <li>Hesabınız üzerinden yapılan tüm işlemlerden siz sorumlusunuz</li>
                                    <li>Hesap bilgilerinizi güncel tutmalısınız</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">3. Kabul Edilebilir Kullanım</h2>
                                <p>Platformumuzu kullanırken aşağıdaki kurallara uymalısınız:</p>
                                <ul className="list-disc pl-6 space-y-2 mt-2">
                                    <li>Doğru ve dürüst bilgiler paylaşın</li>
                                    <li>Diğer kullanıcılara saygılı davranın</li>
                                    <li>Sahte veya yanıltıcı incelemeler yazmayın</li>
                                    <li>Spam veya reklam içerikli paylaşımlar yapmayın</li>
                                    <li>Telif hakkı veya fikri mülkiyet haklarını ihlal etmeyin</li>
                                    <li>Platformun güvenliğini tehlikeye atacak eylemlerden kaçının</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4. İçerik Politikası</h2>
                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">4.1 Kullanıcı İçerikleri</h3>
                                <p>
                                    Kullanıcılar tarafından paylaşılan incelemeler, yorumlar ve puanlamalar kullanıcının
                                    kendi sorumluluğundadır. ServeRS, kullanıcı içeriklerinden yasal olarak sorumlu değildir.
                                </p>

                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2 mt-4">4.2 Yasaklı İçerikler</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>Nefret söylemi veya ayrımcılık</li>
                                    <li>Şiddet teşviki</li>
                                    <li>Kişisel bilgilerin izinsiz paylaşımı</li>
                                    <li>Yasa dışı faaliyetlerin teşviki</li>
                                    <li>Cinsel içerikli veya müstehcen materyaller</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5. Sunucu Listeleme</h2>
                                <p>
                                    ServeRS, yalnızca bir listeleme platformudur. Listelenen sunucuları işletmez veya kontrol etmez.
                                    Sunuculara katılmak tamamen kullanıcının kendi sorumluluğundadır.
                                </p>
                                <ul className="list-disc pl-6 space-y-2 mt-2">
                                    <li>Sunucu bilgilerinin doğruluğunu garanti etmiyoruz</li>
                                    <li>Sunucuların güvenliğinden sorumlu değiliz</li>
                                    <li>Sunucu sahipleri ve kullanıcılar arasındaki anlaşmazlıklardan sorumlu değiliz</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">6. Fikri Mülkiyet</h2>
                                <p>
                                    ServeRS logosu, tasarımı ve yazılımı telif hakkı ile korunmaktadır. İzinsiz kullanım yasaktır.
                                    Metin2 ve ilgili markalar kendi sahiplerine aittir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">7. Hizmet Değişiklikleri</h2>
                                <p>
                                    ServeRS, hizmetlerini önceden bildirimde bulunmaksızın değiştirme, askıya alma veya
                                    sonlandırma hakkını saklı tutar.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">8. Hesap Sonlandırma</h2>
                                <p>
                                    Bu şartları ihlal eden hesaplar uyarılabilir, askıya alınabilir veya kalıcı olarak kapatılabilir.
                                    Hesap kapatma durumunda verileriniz silinebilir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">9. Sorumluluk Reddi</h2>
                                <p>
                                    ServeRS, hizmetlerini "olduğu gibi" sunar. Platformun kesintisiz veya hatasız çalışacağını
                                    garanti etmez. Platformun kullanımından doğabilecek zararlardan sorumlu değildir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">10. Uygulanacak Hukuk</h2>
                                <p>
                                    Bu şartlar Türkiye Cumhuriyeti yasalarına tabidir. Uyuşmazlıklarda Türkiye mahkemeleri yetkilidir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">11. İletişim</h2>
                                <p>
                                    Kullanım şartları hakkında sorularınız için Discord sunucumuza katılabilirsiniz.
                                </p>
                            </section>
                        </>
                    ) : (
                        <>
                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">1. Service Description</h2>
                                <p>
                                    ServeRS is a platform that lists Metin2 private servers and allows users to rate and review them.
                                    By using our platform, you agree to these terms of service.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">2. Account Responsibilities</h2>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>You are responsible for the security of your account</li>
                                    <li>You should not share your password with others</li>
                                    <li>You are responsible for all activities under your account</li>
                                    <li>You must keep your account information up to date</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">3. Acceptable Use</h2>
                                <p>When using our platform, you must follow these rules:</p>
                                <ul className="list-disc pl-6 space-y-2 mt-2">
                                    <li>Share accurate and honest information</li>
                                    <li>Be respectful to other users</li>
                                    <li>Do not write fake or misleading reviews</li>
                                    <li>Do not post spam or advertising content</li>
                                    <li>Do not violate copyright or intellectual property rights</li>
                                    <li>Avoid actions that could compromise platform security</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4. Content Policy</h2>
                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">4.1 User Content</h3>
                                <p>
                                    Reviews, comments, and ratings shared by users are the responsibility of the user.
                                    ServeRS is not legally responsible for user content.
                                </p>

                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2 mt-4">4.2 Prohibited Content</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>Hate speech or discrimination</li>
                                    <li>Incitement to violence</li>
                                    <li>Unauthorized sharing of personal information</li>
                                    <li>Promotion of illegal activities</li>
                                    <li>Sexual or obscene materials</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5. Server Listing</h2>
                                <p>
                                    ServeRS is only a listing platform. We do not operate or control the listed servers.
                                    Joining servers is entirely at the user's own risk.
                                </p>
                                <ul className="list-disc pl-6 space-y-2 mt-2">
                                    <li>We do not guarantee the accuracy of server information</li>
                                    <li>We are not responsible for server security</li>
                                    <li>We are not responsible for disputes between server owners and users</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">6. Intellectual Property</h2>
                                <p>
                                    The ServeRS logo, design, and software are protected by copyright. Unauthorized use is prohibited.
                                    Metin2 and related trademarks belong to their respective owners.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">7. Service Changes</h2>
                                <p>
                                    ServeRS reserves the right to modify, suspend, or terminate its services without prior notice.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">8. Account Termination</h2>
                                <p>
                                    Accounts that violate these terms may be warned, suspended, or permanently closed.
                                    Your data may be deleted upon account closure.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">9. Disclaimer</h2>
                                <p>
                                    ServeRS provides its services "as is". We do not guarantee that the platform will operate
                                    without interruption or error. We are not responsible for damages arising from the use of the platform.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">10. Governing Law</h2>
                                <p>
                                    These terms are subject to the laws of the Republic of Turkey. Turkish courts have jurisdiction in disputes.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">11. Contact</h2>
                                <p>
                                    For questions about terms of service, you can join our Discord server.
                                </p>
                            </section>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
